import { render, staticRenderFns } from "./Autotestcardview.vue?vue&type=template&id=69728f56&scoped=true"
import script from "./Autotestcardview.vue?vue&type=script&lang=js"
export * from "./Autotestcardview.vue?vue&type=script&lang=js"
import style0 from "./Autotestcardview.vue?vue&type=style&index=0&id=69728f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69728f56",
  null
  
)

export default component.exports